// src/components/Hero.js
import React from "react";
import { Link } from "react-router-dom";
import "../styles/Hero.css"
function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-img-wrapper">
          <img
            src="/images/doinaRoHero.jpg"
            alt="Doina"
            className="hero-img"
          />
        </div>
        <div className="hero-text">
          <h2>Bienvenid@ a <span className="highlight">DoinaRo28</span></h2>
          <p className="hero-description">
            Soy <strong>Doina</strong>, autora apasionada por las letras y las historias que inspiran.
            Aquí podrás descubrir mis libros, sumergirte en cada relato y acompañarme en un viaje lleno de emociones.
          </p>
          <Link to="/books" className="btn">Descubrir mis productos</Link>
        </div>
      </div>
    </section>
  );
}

export default Hero;